import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  List,
  ListItem,
  ListItemText,
  makeStyles,
  useTheme,
  Divider,
} from "@material-ui/core";
import { compose } from "recompose";

const useListItemStyles = makeStyles((theme) => ({
  secondary: {
    color: theme.palette.text.disabled,
  },
}));

const FunctionList = ({ onFunctionClicked }) => {
  const theme = useTheme();
  const listItemStyles = useListItemStyles(theme);

  const functionList = [
    {
      title: "avg",
      description: "avg2(tag1, tag2) ... avg{n}(tag1, tag2, ... tag{n})",
      value: "avg2(",
    },
    {
      title: "koos_jr()",
      description:
        "koos_jr(sum) — KOOS JR: converts 7-question raw sum (0–28) to interval score (0–100)",
      value: "koos_jr(",
    },
    {
      title: "hoos_jr()",
      description:
        "hoos_jr(sum) — HOOS JR: converts 6-question raw sum (0–24) to interval score (0–100)",
      value: "hoos_jr(",
    },
  ];

  const handleFunctionItemClicked = (item) => {
    if (!!onFunctionClicked) {
      onFunctionClicked(item.value);
    }
  };

  const renderFunctionItems = (items) => {
    return items.map((item, index) => {
      return (
        <Fragment key={item.title + index}>
          {index > 0 && <Divider component="li" />}
          <ListItem button onClick={(_) => handleFunctionItemClicked(item)}>
            <ListItemText
              primary={item.title.toUpperCase()}
              secondary={item.description}
              classes={listItemStyles}
            />
          </ListItem>
        </Fragment>
      );
    });
  };

  return <List dense>{renderFunctionItems(functionList)}</List>;
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps));

export default enhance(FunctionList);
